import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NormalizeStringService {

  constructor() { }

  normalizeValue(value: string): string {
    const normalizeStr = value
      .toLowerCase()
      .replace(/\s/g, '')
			.replace(/[áàãâä]/gi, "a")
			.replace(/[éè¨ê]/gi, "e")
			.replace(/[íìïî]/gi, "i")
			.replace(/[óòöôõ]/gi, "o")
			.replace(/[úùüû]/gi, "u")
			.replace(/[ç]/gi, "c");
		return normalizeStr;
  }
}
